import { createFileRoute } from '@tanstack/react-router'
import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'

export type NotificationsSearch = {
  category?: string
  siteId?: string
  priority?: string
  unreadOnly?: boolean
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/notifications/'
)({
  validateSearch: (search: Record<string, unknown>): NotificationsSearch => {
    const str = (v: unknown) => (typeof v === 'string' ? v : undefined)
    return {
      category: str(search.category),
      siteId: str(search.siteId),
      priority: str(search.priority),
      unreadOnly:
        search.unreadOnly === true || search.unreadOnly === 'true'
          ? true
          : undefined,
    }
  },
  beforeLoad() {
    requiredRoles([UserRole.ADMIN, UserRole.FACILITY_MANAGER, UserRole.VIEWER])
  },
})
